import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import { generateMetaHead } from '~/utils/head';
export default {
  // headerFixed: false,
  // middleware: ['password-protect'],
  components: {
    LoadingOverlay
  },
  data() {
    return {
      loaded: false,
      sliderValue: 5000
    };
  },
  head() {
    return generateMetaHead({
      title: 'State Licenses | Extra'
    });
  },
  methods: {
    onSignupClick() {
      this.$router.push('/#pricing');
    }
  }
};